import React from 'react'
import {
  DialogComponent
} from '../../shared/dialog/dialog.component'
import InputMask from 'react-input-mask'
import {
  loginApi
} from './login_api'

import { sharedData } from '../../../models/shared_data'

export class LoginEmailRegister extends React.Component {
  constructor(params) {
    super(params)
    this.state = {
      params: {
        email: '',
        password: '',
        phone: ''
      },
      errors: {},
      errorText: ''
    }

    this.register = this.register.bind(this)
  }

  register(e) {
    if(e)
      e.preventDefault()
    if(!this.noErrors())
      return
    this.setState({
      errors: {},
      errorText: ''
    })

    loginApi.registerEmail(this.state.params)
      .subscribe((data)=> {
        if(data.status == 'ok') {
          sharedData.updateData(data.shared_data)
        } else {
          this.setState({
            errorText: data.errors,
            errors: {
              phone: true,
              password: true,
              phone: true
            }
          })
        }
      })
  }

  isError(name) {
    if(this.state.errors[name])
      return 'error'
    return ''
  }

  noErrors() {
    const st = this.state.params
    return (this.isValidPhone() && st.email.length > 0 && st.password.length > 3)
  }

  isValidPhone() {
    const phone = this.state.params.phone.replace(/\D/g,'');
    return phone.length == sharedData.phone_length
  }

  changeParams(name, e) {
    e.preventDefault()

    const v = e.target.value
    this.setState((ps)=> {
      ps.params[name] = v
      return ps
    })
  }

  render() {
    const st = this.state
    // <div className="login-box__sub-link">
    //   <a href='' onClick={ (e)=> this.toState('login', e) }>Войти</a>
    //
    // </div>
    const mask = sharedData.phone_mask

    return (
      <DialogComponent height={st.errorText == '' ? 340 : 370} opened={true} onClose={this.props.onClose}>
        <div className="login-box">
          <div className="h1">Регистрация</div>
          { st.errorText != '' &&
            <div>{ st.errorText }</div>
          }
          <form onSubmit={this.register}>
            <div className="input">
              <input className="input__text" placeholder="email" type="email" value={st.params.email} onChange={(e)=> { this.changeParams('email', e) }}/>
            </div>
            <div className="input">
              <input className="input__text" placeholder="Пароль" type="password" value={st.params.password} onChange={(e)=> { this.changeParams('password', e) }}/>
            </div>
            <div className="input">
              <InputMask
                className="input__text"
                placeholder="Телефон"
                type="text"
                value={st.params.phone}
                onChange={(e)=> { this.changeParams('phone', e) }}
                mask={mask}
              />
            </div>
            <button
              className={ "btn btn--red " +
                (this.noErrors() ? '' : 'btn--disabled')
              }>
              Далее
            </button>
          </form>
        </div>

      </DialogComponent>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/login/login_email_register.component.jsx